import { Pipe, PipeTransform } from "@angular/core";
import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
    name: "phoneFormat"
})
export class PhoneFormatePipe implements PipeTransform {
    transform(phoneNumber: string): string {
        if (!phoneNumber || typeof phoneNumber !== 'string') {
            return '';
        }

        phoneNumber = phoneNumber.trim();

        const digitsOnly = phoneNumber.replace(/\D+/g, '');

        if (digitsOnly.length < 2) {
            return ''; 
        }

        const trimmedNumber = digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly;

        let countryCode = localStorage.getItem('sc_country') || 'US';

        if (countryCode.length > 2) {
            countryCode = countryCode.substring(0, 2).toUpperCase();
        } else {
            countryCode = countryCode.toUpperCase();
        }

        try {
            const number = parsePhoneNumber(trimmedNumber, countryCode as CountryCode);
            let formattedNumber = number.formatNational();

            formattedNumber = formattedNumber.replace(/^0+/, '');
            return formattedNumber;
        } catch (error) {
            console.error('Error parsing phone number:', error);
            return ''; 
        }
    }
}
